/**
 * User Role Enum
 *
 * Defines the roles used for authentication and authorization.
 * Values synced with backend UserRoleEnum.
 * @see backend/src/backend/db/constants/user_role.py
 *
 * Roles:
 * - DOCTOR: Medical professional (prescriber)
 * - PHARMACIST: Pharmacist (dispenser)
 * - API_KEY_MANAGER: API key management access
 * - EUROFARMA_GESTAO_LENA: System administrator (Gestão Lena)
 * - INSTITUTION_RESPONSIBLE: Institutional user
 * - DISTRIBUTOR_RESPONSIBLE: Distributor responsible (uses institution_responsible in DB)
 */

export const UserRole = {
    DOCTOR: "DOCTOR",
    PHARMACIST: "PHARMACIST",
    API_KEY_MANAGER: "API_KEY_MANAGER",
    EUROFARMA_GESTAO_LENA: "EUROFARMA_GESTAO_LENA",
    INSTITUTION_RESPONSIBLE: "INSTITUTION_RESPONSIBLE",
    DISTRIBUTOR_RESPONSIBLE: "DISTRIBUTOR_RESPONSIBLE",
};
